import React from 'react';
import { mov } from '../../content/site';
import { GoBar } from './GoBar';
import styles from './Apps.module.css';

/** 극장의 작품을 차례로 틀어둔다. 패널 어디를 눌러도 극장으로 간다 */
export const Mov: React.FC = () => (
    <a className={styles.mov} href={mov.url}>
        <iframe src={mov.embed} title="극장 상영" tabIndex={-1} />
        <GoBar label="mov.dkdk.me 열기" />
    </a>
);

export default Mov;
